import React, { useState } from "react";
import {
    DataGrid,
    GridFilterPanel } from "../ui";
import FilterAltIcon from '../ui/icons/FilterAlt';
import { styled } from '../ui';
import GridToolbarCustom from './GridToolbarCustom';
import { Box } from "../ui";
import {
  INITIAL_PAGEMODEL,
  PAGESIZEOPTIONLISTDEF
} from "../../constants/constant";
import './CustomDataGrid.css';
//import CustomFilterInput from "./CustomFilterInput";


export default function CustomDataGrid(props) {
  //const [filt, setFilt] = useState([])
  const MyFilterAltIcon = styled(FilterAltIcon)({
    color: 'white',
  });
  const [selectionModel, setSelectionModel] = useState([]);
  const {
    getRowId = "",
    rows = "",
    columns = "",
    loading = false,
    paginationAllowed = true,
    paginationModel = INITIAL_PAGEMODEL,
    paginationMode = "client",
    pageSizeOptionList = PAGESIZEOPTIONLISTDEF,
    disableSelectionOnClick = true,
    onPageDataChange = (e) => e,
    checkboxSelection = false,
    cbPageSizeChange = (e) => e,
    getRowClassName = (params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row',
    mFilterMode = "client",
    mDensity = "compact",
    mOnFilterModelChange = (e) => e,
    mDisableColumnFilter = false,
    hideToolbarFilter = false,
    mFilterPanel = () => <GridFilterPanel />,
    // children,
  } = props;
  const [internalPaginationModel, setInternalPaginationModel] = useState(INITIAL_PAGEMODEL);
  // useEffect(() => {
  //   //console.log("useEffect",internalPaginationModel);
  // }, [internalPaginationModel]);


  /** Handlers */
  const onPaginationModelModelChange = (next) => {
    const model = typeof next === 'number'
      ? { ...internalPaginationModel, page: next }
      : { ...internalPaginationModel, ...next };
    if (paginationMode === 'server') {
      onPageDataChange(model.page);
    } else {
      setInternalPaginationModel(model);
    }
  };


  const onBasePageSizeChange = (mPageSize) => {
    console.log("onBasePageSizeChange", mPageSize);
    if (paginationMode === 'server')
      cbPageSizeChange(mPageSize);
    else
      setInternalPaginationModel({
        ...internalPaginationModel, pageSize: mPageSize
      })
  }

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log("onFilterChange",filterModel)
    mOnFilterModelChange(filterModel)
  }, []);



  const getRowHeight = (rowIndex, columnIndex) => {
    // Get the content of the cell.
    const cellContent = rows[rowIndex][columnIndex];
    // Calculate the height of the cell.
    const height = cellContent.length * 16;
    // Return the height.
    return height;
  };


  return (
    <>
      <Box sx={{
        height: 480,
        width: "100%",
        marginTop: "1%",
      }}>
        {
          paginationMode === "server" ?
            <DataGrid
              disableColumnFilter={mDisableColumnFilter}
              density="compact"
              getRowId={getRowId}
              getRowHeight={() => 'auto'} // Dynamic row height
              rows={rows}
              filterMode={mFilterMode}
              onFilterModelChange={onFilterChange}
              columns={columns}
              getRowClassName={getRowClassName}
              pagination={paginationAllowed}
              page={paginationMode === 'server' ? paginationModel.page : internalPaginationModel.page}
              pageSize={paginationMode === 'server' ? paginationModel.pageSize : internalPaginationModel.pageSize}
              onPageChange={onPaginationModelModelChange}
              onPageSizeChange={onBasePageSizeChange}
              rowCount={paginationModel.rowCount || (rows || []).length}
              rowsPerPageOptions={pageSizeOptionList}
              paginationModel={paginationMode === 'server' ? paginationModel : internalPaginationModel}
              //onPaginationModelChange={onPaginationModelModelChange}
              paginationMode={paginationMode}
              // pageSizeOptions={pageSizeOptionList}
              disableSelectionOnClick={disableSelectionOnClick}
              isCellEditable={() => false}
              experimentalFeatures={{ newEditingApi: true }}
              loading={loading}
              checkboxSelection={checkboxSelection}
              components={{
                ColumnMenuIcon: MyFilterAltIcon,
                FilterPanel: mFilterPanel,
                Toolbar: GridToolbarCustom
              }}
              componentsProps={{
                toolbar: {
                  selectionModel,
                  hideFilter: hideToolbarFilter,
                },
              }}
              // filterModel={{
              //     items: filt
              //   }}
              onSelectionModelChange={(newSelectionModel) => {
                setSelectionModel(newSelectionModel);
              }}
              selectionModel={selectionModel}
              sx={{
                boxShadow: 15,
                border: 2,
                borderRadius: 3,
                borderColor: 'primary.paperborder',
                backgroundColor: "background.paper",
                '& .UiDataGrid-cell:hover': {
                  color: 'brown',
                  backgroundColor: 'lightbrown',
                  fontWeight: 'bold',
                  border: '2px solid #00333e',
                  borderRadius: 2,
                },
                '& .UiDataGrid-columnHeaders': {
                  // backgroundColor:'primary.datagridCol',
                  backgroundColor: 'brown',
                  color: 'white',
                  fontFamily: '"Nunito", sans-serif',
                },
                
              }}

            /> :
            <>
            {/* {console.log("muidata",mDensity)} */}
            <DataGrid
              disableColumnFilter={mDisableColumnFilter}
              getRowId={getRowId}
              getRowHeight={() => 'auto'} // Dynamic row height
              rows={rows}
              density={mDensity}
              columns={columns}
              getRowClassName={getRowClassName}
              pagination={paginationAllowed}
              //   paginationMode={paginationMode}
              //   page={state.page}
              //   onPageChange={onTablePageChangeHandler}
              //   pageSize={state.pageSize}
              //   onPageSizeChange={onTablePageSizeChangeHandler}
              rowCount={paginationModel.rowCount || (rows || []).length}
              //   rowsPerPageOptions={state.pageSizeOptionList}
              paginationModel={paginationMode === 'server' ? paginationModel : internalPaginationModel}
              onPaginationModelChange={onPaginationModelModelChange}
              paginationMode={paginationMode}
              pageSizeOptions={pageSizeOptionList}
              disableSelectionOnClick={disableSelectionOnClick}
              isCellEditable={() => false}
              experimentalFeatures={{ newEditingApi: true }}
              loading={loading}
              checkboxSelection={checkboxSelection}
              components={{
                ColumnMenuIcon: MyFilterAltIcon,
                Toolbar: GridToolbarCustom
              }}
              componentsProps={{
                toolbar: {
                  selectionModel,
                  hideFilter: hideToolbarFilter,
                },
              }}
              // filterModel={{
              //     items: filt
              //   }}
              onSelectionModelChange={(newSelectionModel) => {
                setSelectionModel(newSelectionModel);
              }}
              selectionModel={selectionModel}
              sx={{
                boxShadow: 15,
                border: 2,
                borderRadius: 3,
                borderColor: 'primary.paperborder',
                backgroundColor: "background.paper",
                '& .UiDataGrid-cell:hover': {
                  color: 'brown',
                  backgroundColor: 'lightbrown',
                  fontWeight: 'bold',
                  border: '2px solid #00333e',
                  borderRadius: 2,
                },
                '& .UiDataGrid-columnHeaders': {
                  // backgroundColor:'primary.datagridCol',
                  backgroundColor: 'brown',
                  color: 'white',
                  fontFamily: '"Nunito", sans-serif',
                },
                
              }}

            /></>

        }

      </Box>
    </>
  );
};



//Backup
// '&.UiDataGrid-withBorderColor' : {
//   withBorderColor: "#00333e"
// },
// '& .UiDataGrid-row.Ui-odd ': {
//   backgroundColor: 'primary.datagridrow',
//                 },
// '& .UiDataGrid-row': {
//   backgroundColor: 'background.paper',
//                 },
// '.UiDataGrid-iconButtonContainer': {
//   visibility: 'visible',
//                 },
// '.UiDataGrid-sortIcon': {
//   opacity: 'inherit !important',
//                 },
